import baseUrl from "../config/baseUrl";

const getAllAssignUsers = async ({ token }) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/get-user-name-list`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getAllAssignUsers;
